import { Action } from 'typescript-fsa';

import { createReducer } from '@topconagriculture/frontend-utils';

import {
  addIngredientInOrder,
  changeIngredientNote,
  removeIngredientFromOrder,
  resetOrderIngredients,
  setDeliveryPreview,
  setIngredientIdToAddInOrder,
  setOrderIsEdit,
} from './ingredientsInOrder.actions';
import { IngredientInOrder } from '../../entities/ingredients/ingredients.types';
import { Order } from '../../entities/orders/orders.types';

export type AppOrdersState = {
  readonly orderCreation: {
    readonly orderIsEdit: boolean;
    readonly ingredientsInOrder: IngredientInOrder[];
    readonly ingredientIdToAddInOrder: string | null;
  };
  readonly deliveryPreview: Order | null;
};

export const initialState: AppOrdersState = {
  orderCreation: {
    orderIsEdit: false,
    ingredientsInOrder: [],
    ingredientIdToAddInOrder: null,
  },
  deliveryPreview: null,
};

const appOrderReducer = createReducer(initialState, {
  [addIngredientInOrder.type]: (state: AppOrdersState, action: Action<IngredientInOrder>) => {
    return {
      ...state,
      orderCreation: {
        ...state.orderCreation,
        ingredientsInOrder: [...state.orderCreation.ingredientsInOrder, action.payload],
      },
    };
  },
  [removeIngredientFromOrder.type]: (state: AppOrdersState, action: Action<string>) => {
    const deleteditemIndex = state.orderCreation.ingredientsInOrder.findIndex((ingredient) => {
      return ingredient.id ? ingredient.id === action.payload : ingredient.uiId === action.payload;
    });
    return {
      ...state,
      orderCreation: {
        ...state.orderCreation,
        ingredientsInOrder: [...state.orderCreation.ingredientsInOrder].filter((ingredient) => {
          return ingredient.id ? ingredient.id !== action.payload : ingredient.uiId !== action.payload;
        }),
      },
      deliveryPreview: {
        ...state.deliveryPreview,
        items: state.deliveryPreview?.items?.filter((_, index) => index !== deleteditemIndex),
      },
    };
  },
  [changeIngredientNote.type]: (state: AppOrdersState, action: Action<{ uiId: string; notes: string }>) => {
    const ingredientsInOrder = [...state.orderCreation.ingredientsInOrder];
    const target = ingredientsInOrder.find((ingredient) => {
      return ingredient.id ? ingredient.id === action.payload.uiId : ingredient.uiId === action.payload.uiId;
    });
    const targetIndex = ingredientsInOrder.indexOf(target!);
    ingredientsInOrder[targetIndex!] = { ...target!, notes: action.payload.notes };

    return {
      ...state,
      orderCreation: {
        ...state.orderCreation,
        ingredientsInOrder,
      },
    };
  },
  [resetOrderIngredients.type]: (state: AppOrdersState) => {
    return {
      ...state,
      orderCreation: {
        ...state.orderCreation,
        ingredientsInOrder: [],
      },
      deliveryPreview: null,
    };
  },
  [setOrderIsEdit.type]: (state: AppOrdersState, action: Action<boolean>) => ({
    ...state,
    orderCreation: { ...state.orderCreation, orderIsEdit: action.payload },
  }),
  [setIngredientIdToAddInOrder.type]: (state: AppOrdersState, action: Action<string | null>) => ({
    ...state,
    orderCreation: { ...state.orderCreation, ingredientIdToAddInOrder: action.payload },
  }),
  [setDeliveryPreview.type]: (state: AppOrdersState, action: ReturnType<typeof setDeliveryPreview>) => ({
    ...state,
    deliveryPreview: action.payload,
  }),
});

export default appOrderReducer;
